<div class="logo">
  <svg-icon
    [icon]="'icon_' + logo"
    class="company {{ coBrand }}"
    i18n-title="@@login.logo.title"
    title="Logo"></svg-icon>
  @if (!hideTitle()) {
    <div class="title" i18n="@@dmb-web.title.long">digital media base</div>
  }
</div>
